import type { CreateReturnRequestDto, ReturnRequestDto } from "../generated/schema";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";

export async function publicCreateReturnRequest(
	body: CreateReturnRequestDto,
): Promise<ReturnRequestDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		{ params: { header: getPublicAuthHeader() }, body: body as any },
	);
	if (error) throw error;
	return data as ReturnRequestDto;
}

export function usePublicCreateReturnRequest() {
	return usePublicApiMutation(
		"post",
		"/public/return-request",
		{
			mapVariables: (body: CreateReturnRequestDto) => ({
				params: { header: getPublicAuthHeader() },
				body,
			}),
		},
	);
}
